export default __webpack_public_path__ + "static/media/dashboard-icon.2ddaa012.svg";